var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"fb-root"}}),_c('div',{staticClass:"fb-customerchat",attrs:{"id":"fb-customer-chat"}})])
}]

export { render, staticRenderFns }